import Capabilities from '../../App/OrgView/Capabilities';
import { Input } from 'components/ui/input';
import { Label } from 'components/ui/label';

const AccessGroupsForm = ({ data, newData, onChangeData }: IAccessGroups) => {
  const combinedData = { ...data, ...newData };

  const onChangeCapas = (capas: string[]) => {
    onChangeData('capabilities', capas);
  };

  return (
    <div className="grid gap-y-4">
      <div>
        <Label htmlFor="groupId">Group id (filled automatically by server)</Label>
        <Input
          type="text"
          id="groupId"
          className="w-100"
          value={combinedData.groupId}
          onChange={e => onChangeData('groupId', e.target.value)}
          placeholder="Group id"
          disabled
        />
      </div>
      <div>
        <Label htmlFor="orgId">Org id (filled automatically by server)</Label>
        <Input
          type="text"
          id="orgId"
          className="w-100"
          value={combinedData.orgId}
          onChange={e => onChangeData('orgId', e.target.value)}
          placeholder="Org id"
          disabled={true}
        />
      </div>
      <div>
        <Label htmlFor="groupName">Group name</Label>
        <Input
          type="text"
          id="groupName"
          className="w-100"
          value={combinedData.groupName}
          onChange={e => onChangeData('groupName', e.target.value)}
          placeholder="Group name"
        />
      </div>
      <div>
        <Label htmlFor="externalGroups">External groups (comma separated list)</Label>
        <Input
          type="text"
          id="externalGroups"
          className="w-100"
          value={combinedData.externalGroups}
          onChange={e => onChangeData('externalGroups', e.target.value)}
          placeholder="External groups"
        />
      </div>
      <div>
        <Capabilities
          capas={data['capabilities'] || []}
          newCapas={newData['capabilities']}
          onChangeCapas={onChangeCapas}
        />
      </div>
      <div>
        <Label htmlFor="isDefaultGroup">Is default group</Label>
        <Input
          type="Checkbox"
          id="isDefaultGroup"
          name="isDefaultGroup"
          className="w-100"
          checked={
            combinedData.isDefaultGroup === true ||
            (combinedData.isDefaultGroup as unknown as string) === 'isDefaultGroup'
          }
          value={'isDefaultGroup'}
          onChange={() => {
            const checked =
              combinedData.isDefaultGroup === true ||
              (combinedData.isDefaultGroup as unknown as string) === 'isDefaultGroup';
            onChangeData('isDefaultGroup', !checked);
          }}
          placeholder="Is default group"
        />
      </div>
    </div>
  );
};

interface IAccessGroups {
  data: Partial<TVaultAccessGroup & { isDefaultGroup?: boolean | string }>;
  newData: Partial<TVaultAccessGroup & { isDefaultGroup?: boolean | string }>;
  onChangeData: (field: keyof TVaultAccessGroup, value: string | boolean | string[]) => void;
}

export default AccessGroupsForm;
